<template>
  <modal-form v-model="show" :submit="submit" :show-submit="false">
    <template v-slot:title>
      <v-icon class="mr-2 fas fa-edit"></v-icon>
      Cancelamento de Proposta
    </template>
    <template v-slot:body>
      <input-textarea
        rows="5"
        required
        label="Motivo de Cancelamento"
        v-model="model.MotivoCancelamento"
      />
    </template>
    <template v-slot:[`actions.append`]>
      <v-btn dark color="error" type="submit">
        <v-icon class="mr-2" small>fas fa-exclamation-triangle</v-icon>
        Confirmar
      </v-btn>
    </template>
  </modal-form>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      model: {},
    };
  },
  methods: {
    openModal (sender) {
      const th = this;
      th.show = true;
      if (sender) {
        th.$api.Multiplo.Post('FindRecordProposta', { guidID: sender.Codigo }).then(response => {
          if (th.$api.UI.PostLoadData(response, true)) {
            th.$set(th, 'model', response);
          }
        });
      }
    },
    submit () {
      const th = this;
      const dto = {
        dto: {
          CodigoProposta: this.model.Codigo,
        },
        textoMotivoCancelamento: th.model.MotivoCancelamento,
      };
      th.$api.Multiplo.Post('PropostaCancelar', dto).then(response => {
        if (th.$api.UI.PostAction(response)) {
          th.show = false;
          th.$emit('close', !response.error);
        }
      });
    },
  },
};
</script>
